define((require) => {
    "use strict";

    var AbstractGuidelineView = require("ui/editor/guideline/AbstractGuidelineView"),
        GuidelineModel        = require("ui/editor/guideline/GuidelineModel"),
        template              = require("ui/editor/guideline/HorizontalGuidelineView.tpl");

    return AbstractGuidelineView.extend("HorizontalGuidelineView", {
        className: "horizontal-guideline",
        template: template,

        _scrollbar: null,

        _getClientXY: function(e) {
            return e.clientY;
        },

        _getDirection: function() {
            return GuidelineModel.HORIZONTAL;
        },

        _getTopLeft: function() {
            return "top";
        },

        _getTooltipLabel: function() {
            return "y: ";
        },

        _getWidthHeight: function() {
            return "height";
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/guideline/HorizontalGuidelineView.js